import React, { useState } from "react";
import SideBar from "../components/common/SideBar";
import Navbar from "../components/common/Navbar";
import ScoreBoard from "../components/createPost/ScoreBoard";
import Footer from "../components/common/Footer";
import PostSelection from "../components/createPost/PostSelection";
import TipsSection from "../components/createPost/TipsSection";
import Notifications from "../components/common/Notifications";
import Activity from "../components/dashBoard/Activity";
import PostingTime from "../components/dashBoard/PostingTime";
import ImpressionRate from "../components/dashBoard/ImpressionRate";
import Insights from "../components/dashBoard/Insights";
import MyTopPost from "../components/dashBoard/MyTopPost";
import TopPost from "../components/dashBoard/TopPost";
import Hook from "../components/dashBoard/Hook";
import EmergingKeyword from "../components/dashBoard/EmergingKeyword";
import CTA from "../components/dashBoard/CTA";
import EngagementLevel from "../components/dashBoard/EngagementLevel";
import MediaElement from "../components/dashBoard/MediaElement";
import IndrustryEngagement from "../components/dashBoard/IndrustryEngagement";

const Dashboard = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const scores = [
    "Views",
    "Followers",
    "Engagement Rate",
    "Interactions",
    "Views",
    "Followers",
  ];

  return (
    <div className="flex flex-col h-screen bg-black-0">
      <div className="hidden md:block">
        <Navbar />
      </div>

      <div className="flex flex-1 overflow-hidden">
        <SideBar
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <main className="flex-1 overflow-y-auto p-6 space-y-6 ml-28 relative">
          <ScoreBoard scores={scores} />
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <div className="border border-gradient-04 rounded-2xl">
              <Activity />
            </div>
            <div className="border border-gradient-04 rounded-2xl">
              <PostingTime />
            </div>
            <div className="border border-gradient-04 rounded-2xl">
              <ImpressionRate />
            </div>
          </div>
          <div className="columns-1 lg:columns-2 gap-4 [column-fill:_balance]">
            <div className="mb-4 break-inside-avoid border border-gradient-04 rounded-2xl">
              <Insights />
            </div>
            <div className="mb-4 break-inside-avoid border border-gradient-04 rounded-2xl">
              <TopPost />
            </div>
            <div className="mb-4 break-inside-avoid border border-gradient-04 rounded-2xl">
              <EmergingKeyword />
            </div>
            <div className="mb-4 break-inside-avoid border border-gradient-04 rounded-2xl">
              <EngagementLevel />
            </div>
            <div className="mb-4 break-inside-avoid border border-gradient-04 rounded-2xl">
              <MyTopPost />
            </div>
            <div className="mb-4 break-inside-avoid border border-gradient-04 rounded-2xl">
              <Hook />
            </div>
            <div className="mb-4 break-inside-avoid border border-gradient-04 rounded-2xl">
              <CTA />
            </div>
            <div className="mb-4 break-inside-avoid border border-gradient-04 rounded-2xl">
              <MediaElement />
            </div>
            <div className="mb-4 break-inside-avoid border border-gradient-04 rounded-2xl">
              <IndrustryEngagement />
            </div>
          </div>
        </main>
      </div>

      {/* Bottom Section */}
      <Footer />
      {/* <Notifications /> */}
    </div>
  );
};

export default Dashboard;
